
export const GET_SYSTEM_USERS = "GET_SYSTEM_USERS"
export const GET_SYSTEM_USERS_SUCCESS = "GET_SYSTEM_USERS_SUCCESS"
export const GET_SYSTEM_USERS_FAIL = "GET_SYSTEM_USERS_FAIL"

export const ADD_NEW_SYSTEM_USER = "ADD_NEW_SYSTEM_USER"
export const ADD_NEW_SYSTEM_USER_SUCCESS = "ADD_NEW_SYSTEM_USER_SUCCESS"
export const ADD_NEW_SYSTEM_USER_FAIL = "ADD_NEW_SYSTEM_USER_FAIL"

export const UPDATE_SYSTEM_USER = "UPDATE_SYSTEM_USER"
export const UPDATE_SYSTEM_USER_SUCCESS = "UPDATE_SYSTEM_USER_SUCCESS"
export const UPDATE_SYSTEM_USER_FAIL = "UPDATE_SYSTEM_USER_FAIL"

export const DELETE_SYSTEM_USER = "DELETE_SYSTEM_USER"
export const DELETE_SYSTEM_USER_SUCCESS = "DELETE_SYSTEM_USER_SUCCESS"
export const DELETE_SYSTEM_USER_FAIL = "DELETE_SYSTEM_USER_FAIL"
